import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import logo from "../pages/asset/logo.jpg";

const css = `
  @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@400;500;600&display=swap');

  .cnav * { box-sizing: border-box; }

  /* ── FIXED NAV ── */
  .cnav {
    position: fixed !important;
    top: 0; left: 0; right: 0;
    z-index: 9999;
    font-family: 'DM Sans', sans-serif;
    transition: background 0.4s, box-shadow 0.4s;
  }
  .cnav.scrolled {
    background: rgba(10,25,49,0.99) !important;
    backdrop-filter: blur(20px);
    -webkit-backdrop-filter: blur(20px);
    box-shadow: 0 4px 32px rgba(0,0,0,0.45);
  }
  .cnav.top {
    background: rgba(10,25,49,0.92);
    backdrop-filter: blur(12px);
    -webkit-backdrop-filter: blur(12px);
  }
  .cnav-border {
    border-bottom: 1px solid rgba(201,168,76,0.2);
  }

  /* ── SPACER: pushes page content below the fixed nav ── */
  .cnav-spacer {
    height: 76px;
    width: 100%;
    flex-shrink: 0;
  }

  /* ── INNER ── */
  .cnav-inner {
    max-width: 1400px; margin: 0 auto;
    padding: 0 40px;
    height: 76px;
    display: flex; align-items: center;
    gap: 24px;
  }
  @media (max-width: 768px) { .cnav-inner { padding: 0 16px; } }

  /* ── BRAND ── */
  .cnav-brand {
    display: flex; align-items: center; gap: 11px;
    text-decoration: none; flex-shrink: 0;
  }
  .cnav-brand-logo {
    height: 44px; width: 44px;
    border-radius: 9px;
    border: 2px solid rgba(201,168,76,0.45);
    object-fit: cover;
    transition: border-color 0.2s, box-shadow 0.2s;
    display: block;
    flex-shrink: 0;
  }
  .cnav-brand:hover .cnav-brand-logo {
    border-color: #C9A84C;
    box-shadow: 0 0 0 3px rgba(201,168,76,0.15);
  }
  .cnav-brand-text {
    display: flex; flex-direction: column;
    line-height: 1.2;
  }
  .cnav-brand-name {
    font-family: 'Playfair Display', serif;
    font-size: 16px; font-weight: 700;
    color: #ffffff;
    letter-spacing: 0.2px;
    white-space: nowrap;
  }
  .cnav-brand-tagline {
    font-size: 10px; font-weight: 500;
    letter-spacing: 1.8px; text-transform: uppercase;
    color: #C9A84C;
    white-space: nowrap;
  }

  /* ── DESKTOP LINKS ── */
  .cnav-links {
    display: flex; align-items: center;
    gap: 2px; list-style: none;
    margin: 0; padding: 0;
    flex: 1; justify-content: center;
  }
  @media (max-width: 900px) { .cnav-links { display: none; } }

  .cnav-link {
    position: relative;
    display: block;
    padding: 8px 13px;
    border-radius: 8px;
    text-decoration: none;
    font-size: 13.5px; font-weight: 500;
    color: rgba(255,255,255,0.72);
    letter-spacing: 0.2px;
    transition: color 0.2s, background 0.2s;
    white-space: nowrap;
  }
  .cnav-link:hover {
    color: #ffffff;
    background: rgba(255,255,255,0.07);
  }
  .cnav-link.active {
    color: #C9A84C;
    background: rgba(201,168,76,0.1);
    font-weight: 600;
  }
  .cnav-link.active::after {
    content: '';
    position: absolute;
    bottom: 3px; left: 50%;
    transform: translateX(-50%);
    width: 18px; height: 2px;
    background: #C9A84C;
    border-radius: 2px;
  }

  /* ── RIGHT ACTIONS ── */
  .cnav-actions {
    display: flex; align-items: center;
    gap: 10px; flex-shrink: 0;
  }
  .cnav-apply {
    display: inline-flex; align-items: center; gap: 6px;
    background: #C9A84C; color: #0A1931;
    font-weight: 700; font-size: 13px;
    padding: 10px 20px; border-radius: 100px;
    text-decoration: none;
    transition: background 0.2s, transform 0.15s, box-shadow 0.2s;
    white-space: nowrap;
    font-family: 'DM Sans', sans-serif;
    box-shadow: 0 2px 10px rgba(201,168,76,0.25);
  }
  .cnav-apply:hover {
    background: #E8C97A;
    transform: translateY(-1px);
    box-shadow: 0 5px 18px rgba(201,168,76,0.35);
  }
  .cnav-login {
    display: inline-flex; align-items: center;
    background: transparent;
    color: rgba(255,255,255,0.7);
    font-weight: 500; font-size: 13px;
    padding: 9px 16px; border-radius: 100px;
    border: 1px solid rgba(255,255,255,0.2);
    text-decoration: none;
    transition: border-color 0.2s, color 0.2s;
    white-space: nowrap;
    font-family: 'DM Sans', sans-serif;
  }
  .cnav-login:hover { border-color: #C9A84C; color: #C9A84C; }

  /* hide login on mobile to save space */
  @media (max-width: 900px) { .cnav-login { display: none; } }

  /* ── HAMBURGER ── */
  .cnav-burger {
    display: none;
    flex-direction: column;
    gap: 5px;
    cursor: pointer;
    background: rgba(255,255,255,0.06);
    border: 1px solid rgba(201,168,76,0.3);
    padding: 9px 10px;
    border-radius: 9px;
    transition: background 0.2s;
    flex-shrink: 0;
  }
  .cnav-burger:hover { background: rgba(201,168,76,0.1); }
  @media (max-width: 900px) { .cnav-burger { display: flex; } }
  .cnav-burger span {
    display: block; width: 20px; height: 2px;
    background: #C9A84C;
    border-radius: 2px;
    transition: transform 0.3s, opacity 0.3s;
  }
  .cnav-burger.open span:nth-child(1) { transform: translateY(7px) rotate(45deg); }
  .cnav-burger.open span:nth-child(2) { opacity: 0; }
  .cnav-burger.open span:nth-child(3) { transform: translateY(-7px) rotate(-45deg); }

  /* ── MOBILE DRAWER ── */
  .cnav-drawer {
    position: fixed;
    top: 76px; left: 0; right: 0;
    z-index: 9998;
    background: rgba(8, 17, 35, 0.99);
    backdrop-filter: blur(24px);
    -webkit-backdrop-filter: blur(24px);
    border-bottom: 1px solid rgba(201,168,76,0.12);
    padding: 12px 16px 20px;
    display: flex; flex-direction: column; gap: 3px;
    transform: translateY(-10px);
    opacity: 0;
    pointer-events: none;
    transition: opacity 0.25s ease, transform 0.25s ease;
    max-height: calc(100vh - 76px);
    overflow-y: auto;
  }
  .cnav-drawer.open {
    opacity: 1;
    transform: translateY(0);
    pointer-events: all;
  }
  .cnav-drawer-link {
    display: flex; align-items: center;
    padding: 13px 16px;
    border-radius: 10px;
    text-decoration: none;
    font-size: 15px; font-weight: 500;
    color: rgba(255,255,255,0.75);
    border-bottom: 1px solid rgba(255,255,255,0.05);
    transition: background 0.2s, color 0.2s;
  }
  .cnav-drawer-link:last-of-type { border-bottom: none; }
  .cnav-drawer-link:hover {
    background: rgba(201,168,76,0.08);
    color: #E8C97A;
  }
  .cnav-drawer-link.active {
    background: rgba(201,168,76,0.1);
    color: #C9A84C;
    font-weight: 600;
  }
  .cnav-drawer-divider {
    height: 1px;
    background: rgba(255,255,255,0.07);
    margin: 8px 0;
  }
  .cnav-drawer-actions {
    display: flex; gap: 10px;
    padding: 4px 0;
    flex-wrap: wrap;
  }
  .cnav-drawer-actions .cnav-apply {
    flex: 1; justify-content: center;
  }
  .cnav-drawer-actions .cnav-login {
    display: inline-flex;
    flex: 1; justify-content: center;
  }
`;

const navLinks = [
  { to: "/",            label: "Home"         },
  { to: "/about",       label: "About"        },
  { to: "/admissions",  label: "Admissions"   },
  { to: "/charter",     label: "Partnerships" },
  { to: "/prospectus",  label: "Prospectus"   },
  { to: "/gallery_events", label: "Gallery"   },
  { to: "/contact",     label: "Contact"      },
];

const CustomNavbar = () => {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  // Close drawer on route change
  useEffect(() => { setOpen(false); }, [location.pathname]);

  const isActive = (to) =>
    to === "/" ? location.pathname === "/" : location.pathname.startsWith(to);

  return (
    <>
      <style>{css}</style>

      {/* FIXED NAV */}
      <nav className={`cnav cnav-border ${scrolled ? "scrolled" : "top"}`}>
        <div className="cnav-inner">

          {/* Brand / Logo */}
          <Link to="/" className="cnav-brand">
            <img src={logo} alt="Dr AQ Khan College" className="cnav-brand-logo" />
            <div className="cnav-brand-text">
              <span className="cnav-brand-name">Dr A.Q. Khan College</span>
              <span className="cnav-brand-tagline">Science &amp; Technology</span>
            </div>
          </Link>

          {/* Desktop Links */}
          <ul className="cnav-links">
            {navLinks.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  className={`cnav-link${isActive(l.to) ? " active" : ""}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>

          {/* Right actions */}
          <div className="cnav-actions">
            <Link to="/login" className="cnav-login">Login</Link>
            <Link to="/admissions" className="cnav-apply">Apply Now →</Link>
            <button
              className={`cnav-burger${open ? " open" : ""}`}
              onClick={() => setOpen((o) => !o)}
              aria-label="Toggle menu"
            >
              <span /><span /><span />
            </button>
          </div>
        </div>

        {/* Mobile Drawer */}
        <div className={`cnav-drawer${open ? " open" : ""}`}>
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className={`cnav-drawer-link${isActive(l.to) ? " active" : ""}`}
            >
              {l.label}
            </Link>
          ))}
          <div className="cnav-drawer-divider" />
          <div className="cnav-drawer-actions">
            <Link to="/admissions" className="cnav-apply">📄 Apply Now</Link>
            <Link to="/login" className="cnav-login">Login</Link>
          </div>
        </div>
      </nav>

      {/* SPACER — pushes all page content below the fixed nav */}
      <div className="cnav-spacer" />
    </>
  );
};

export default CustomNavbar;